import * as React from 'react';
import { IIconProps } from './IIconProps';

const General: React.FunctionComponent<IIconProps> = ({ size = 'sm', color = "currentColor" }) => {
    return <svg width={16} height={17} viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx={12} cy="4.5" r={2} fill={color} />
        <circle cx={12} cy="12.5" r={2} fill={color} />
        <circle cx={4} cy="4.5" r={2} fill={color} />
        <circle cx={4} cy="12.5" r={2} fill={color} />
    </svg>
};

export default General;
